<template>
  <div id="app">
    <router-view />
    <div class="dialog-wx" id="dialog-wx">
      <div class="dialog-wx-bg"></div>
      <div class="dialog-wx-con">
        <img src="@/assets/images_member/20230828/img1.png" class="dialog-wx-con-img1" alt="">
        <div class="dialog-wx-con-img2">关注幸福公社公众号新鲜资讯早知道</div>
        <img :src="imgSrc" alt="" class="dialog-wx-con-img3">
        <div class="dialog-wx-con-txt">长按二维码识别添加</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getWxPublicInfo} from '@/api/person'
import { WHITE_PATHS } from '@/store/mutation-types'
export default {
  name: 'App',
  data() {
    return {
      imgSrc: ''
    }
  },
  mounted () {
    if (WHITE_PATHS.indexOf(this.$route.path) !== -1) {
      return
    }
    setTimeout(function () {
      getWxPublicInfo().then(res => {
        this.service_qr_code = res.data.service_qr_code
        this.imgSrc = res.data.public_qrcode
      })
    }, 1000)
  },
  methods: {
  }
}
</script>

<style lang="less">
.dialog-wx {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100vh;
  display: none;

  .dialog-wx-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background-color: rgba(0, 0, 0, .6);

  }

  .dialog-wx-con {
    position: absolute;
    top: 134px;
    left: 40px;
    width: calc(100% - 80px);
    z-index: 991;
    background-color: #FFFFFF;
    border-radius: 20px;
    padding-bottom: 30px;
    overflow: hidden;
    box-sizing: border-box;

    .dialog-wx-con-img1 {
      width: 100%;
      display: block;

    }

    .dialog-wx-con-img2 {
      width: 100%;
      display: block;
      padding: 16px 50px;
      box-sizing: border-box;
      text-align: center;
      font-size: 20px;
      line-height: 30px;
      color: #333;
      font-weight: 600;
    }

    .dialog-wx-con-img3{
      width: 130px;
      height: 130px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .dialog-wx-con-txt{
      color: #000;
      font-size: 12px;
      text-align: center;
    }

    .dialog-wx-btn {
      width: 240px;
      background: linear-gradient(98deg, #3E3E3E 0%, #3E3E3E 100%);
      margin-left: 50%;
      transform: translateX(-50%);
      height: 54px;
      border-radius: 100px;
      text-align: center;
      font-size: 18px;
      color: #F0E1C0;
      font-weight: 600;
      line-height: 54px;

    }
  }
}

* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  height: 100%;
}

.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue